import React, { Component } from 'react';

import "./error.css";

class Error extends Component {
  render() {
    return (
      <div>
        Sorry, something's gone wrong.
        Please <a className="error-link" href="/contact-us">contact us</a> so
        we can look into this
      </div>
    );
  }
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/elearning/error.jsx